var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * A simple async delay implementation
 * @param delay wait time before resolving the promise
 * @returns the delay promise
 */
const sleep = (delay) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, _reject) => {
        setTimeout(() => {
            resolve(true);
        }, delay);
    });
});
export { sleep };
//# sourceMappingURL=Sleep.js.map